export const ReportingDashboardConstant = {
    API: 'ReportingDashboard'
}

export const  ReportingDashboarAPIConstant = {
    GETFACILITYFIELDMAPPINGS: `${ReportingDashboardConstant.API}/GetFacilityFieldMappings`,
    GETCHANGEREQUESTSTATISTICS: `${ReportingDashboardConstant.API}/GetChangeRequestStatistics`,
    GETPRIORITYCOMPLIANCESTATISTICS: `${ReportingDashboardConstant.API}/GetPriorityComplianceStatistics`,
    GETMONTHCOMPLIANCESTATISTICS: `${ReportingDashboardConstant.API}/GetMonthComplianceStatistics`,
    GETACDBSCCOMPLIANCESTATISTICS: `${ReportingDashboardConstant.API}/GetAcdBscComplianceStatistics`,
    GETAVERAGEOPENDAYSCOMPLIANCESTATISTICS: `${ReportingDashboardConstant.API}/GetAverageOpenDaysComplianceStatistics`,
}